const cache = new Map();

export async function fetchSentiment(slug) {
  if (cache.has(slug)) return cache.get(slug);
  try {
    const r = await fetch(`/api/sentiment/${slug}`);
    if (!r.ok) {
      if (r.status === 404) return null;
      throw new Error(`HTTP ${r.status}`);
    }
    const data = await r.json();
    cache.set(slug, data);
    return data;
  } catch (e) {
    console.warn("[sentiment] fetch failed:", e.message);
    return null;
  }
}

export async function refreshSentiment(slug) {
  try {
    const r = await fetch(`/api/sentiment/${slug}/refresh`, { method: "POST" });
    cache.delete(slug);
    return await r.json();
  } catch (e) {
    return { error: e.message };
  }
}
